import { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Icon, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { Chip } from '@mui/material';
import { VTextField, VForm, useVForm, VTextFieldData, VFieldMoney, IVFormErrors, AutoCompleteProdutos, AutoCompleteCliente, AutoCompleteOperacoes, AutoCompleteFabrica } from '../../../shared/forms';
import { FerramentasDeDetalheVendas } from '../../../shared/components';
import { LayoutBaseVendas } from '../../../shared/layouts';
import { v4 as uuidv4 } from 'uuid';
import { PedidoDiretoService } from '../../../shared/services/api/vendas/pedidodireto/PedidoDiretoService';
import Alert from '@mui/material/Alert';
import { alpha, useTheme } from '@mui/material/styles';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import PDFPedidos from './ImpressaoDireto';
import { AutoCompleteFabrica01 } from '../../../shared/forms/AutoCompleteFabrica01';
import PDFPedidos1 from './ImpressaoDireto1';
import PDFPedidospequeno from './ImpressaoDiretopequeno';

interface IFormData {
  idcli: string;
  idoperacao: string;
  dataoperacao: Date;
  emissao: Date;
  numero: number;
  valor: number;
}
interface IitensPedidoDiretoDialog {
  iditens: string;
  idprod: string;
  idfabrica: string;
  descricao: string;
  un: string;
  ean: string;
  nome: string;
  codfabrica: string;
  quantidade: number;
  preco: number;
  total: number;
}
interface IItensids {
  iditens: string;
}
const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'numero'>> = yup.object().shape({
  idcli: yup.string().required(),
  idoperacao: yup.string().required(),
  emissao: yup.date().required(),
  dataoperacao: yup.date().required().test('valid-date', 'Selecione uma data válida', function (value) {
    const currentDate = new Date();
    if (!value || value > currentDate || value.getDate() < currentDate.getDate() - 365) return false;
    return true;
  }),
  valor: yup.number().required(),
});

export const DetalhePedidoDireto: React.FC = () => {
  const { id = 'novo' } = useParams<'id'>();
  const navigate = useNavigate();
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const okButtonRef = useRef<HTMLButtonElement>(null);
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<string | null>(null);
  const [statuss, setStatuss] = useState(true);
  const [iditens, setIditens] = useState('');
  const [rows, setRows] = useState<IitensPedidoDiretoDialog[]>([]);
  const [rowsids, setRowsids] = useState<IItensids[]>([]);
  const [dadositens, setDadositens] = useState<IitensPedidoDiretoDialog>();
  const [venda, setvenda] = useState<boolean | null>();
  const [edit, setEdit] = useState(false);
  const [tipo, setTipo] = useState('p.ean');
  const [uuidcli, setUuidcli] = useState('');
  const [idfabrica, setIdfabrica] = useState('');
  const [uuidprod, setUuidprod] = useState('');
  const [codigobarra, setcodigobarra] = useState('');
  const codigoref = useRef<HTMLInputElement>(null);
  const qtdref = useRef<HTMLInputElement>(null);
  const nomeref = useRef<HTMLInputElement>(null);
  const [quantidade, setQuantidade] = useState('');
  const [openalert, setOpenAlert] = useState(false);
  const [msg, setMsg] = useState('');
  const showError = (message: string) => {
    setErrorMessage(message);
    setIsLoading(false);
    setErrorDialogOpen(true);
  };


  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      PedidoDiretoService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
            navigate('/pedidodireto');
          } else {
            formRef.current?.setData(result);
            setUuidcli(result.idcli);
            setRows(result.itens);
            if (result.itens.length != 0) {
              setEdit(true);
            } else {
              setEdit(false);
            }
          }
        });
    } else {
      formRef.current?.setData({
        idoperacao: '0a838689-a2e0-4d3a-983c-ce400c871f19',
        emissao: new Date(),
        dataoperacao: new Date(),
      });
      setRows([]);
      setvenda(null);
      setStatuss(true);
      setEdit(false);
    }
  }, [id]);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (errorDialogOpen && event.key === 'Escape') {
        setErrorDialogOpen(false);
        codigoref.current?.focus();
      }
      if (errorDialogOpen && event.key === 'Enter') {
        setErrorDialogOpen(false);
        codigoref.current?.focus();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [errorDialogOpen]);

  useEffect(() => {
    if (errorDialogOpen && okButtonRef.current) {
      setTimeout(() => {
        okButtonRef.current?.focus();
      }, 100);
    }
  }, [errorDialogOpen]);

  useEffect(() => {
    codigoref.current?.focus();
  }, [formRef]);

  const handlebusca = useCallback(async (codigobarra: any) => {
    setIsLoading(true);
    try {
      PedidoDiretoService.getProdutos(tipo, idfabrica, uuidcli, codigobarra)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            showError(result.message || 'Produto não encontrado');
            return;
          } else {
            handleItens({
              iditens: uuidv4(),
              idprod: result.idprod,
              idfabrica: result.idfabrica,
              quantidade: Number(quantidade),
              preco: result.preco,
              total: result.preco * Number(quantidade),
              descricao: result.descricao,
              codfabrica: result.codfabrica,
              ean: result.ean,
              nome: result.nome,
              un: result.un,
            })
          }
          setcodigobarra('');
        });
      setIsLoading(false);
      setTimeout(() => {
        qtdref.current?.focus();
        setQuantidade('');
      }, 0);

    } catch (error: any) {
      setIsLoading(false);
      setMsg(error.message)
      setOpenAlert(true);
      setTimeout(() => {
        codigoref.current?.focus();
      }, 0);
    }
  }, [codigobarra]);

  useEffect(() => {
    const totalSum = rows.reduce((accumulator, currentItem) => accumulator + currentItem.total, 0);
    formRef.current?.setFieldValue('valor', totalSum);
  }, [rows]);

  const handleSave = (dados: IFormData) => {
    if (rows.length != 0) {
      formValidationSchema.
        validate(dados, { abortEarly: false })
        .then((dados) => {
          setIsLoading(true);
          if (id === 'novo') {
            PedidoDiretoService
              .create(dados, rows)
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  setMsg(result.message);
                  setOpenAlert(true);
                } else {
                  if (isSaveAndClose()) {
                    navigate('/pedidodireto');
                  } else {
                    navigate(`/pedidodireto/${result}`);
                  }
                }
              });
          } else {
            PedidoDiretoService
              .updateById(id, dados, rows, rowsids)
              .then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                  setMsg(result.message);
                  setOpenAlert(true);
                } else {
                  if (isSaveAndClose()) {
                    navigate('/pedidodireto');
                  }
                }
              });
          }
        })
        .catch((errors: yup.ValidationError) => {
          const validationErrors: IVFormErrors = {};
          errors.inner.forEach(error => {
            if (!error.path) return;
            validationErrors[error.path] = error.message;

          });
          formRef.current?.setErrors(validationErrors);
        });
    } else {
      setMsg('A saída deve conter no mínimo um ítem.');
      setOpenAlert(true);
    }
  };
  const handleDeleteEntrada = (id: string) => {
    if (confirm('Realmente deseja apagar?')) {
      PedidoDiretoService.deleteById(id)
        .then(result => {
          if (result instanceof Error) {
            setMsg(result.message);
            setOpenAlert(true);
          } else {
            setMsg('Registro apagado com sucesso!');
            setOpenAlert(true);
            navigate('/pedidodireto');
          }
        });
    }
  };
  const handleDelete = (id: string) => {
    if (confirm('Realmente deseja apagar?')) {
      const meuObjeto = { iditens: id };
      rowsids.push(meuObjeto);
      const indexToDelete = rows.findIndex((item) => item.iditens === id);
      if (indexToDelete !== -1) {
        const updatedList = [...rows];
        updatedList.splice(indexToDelete, 1);
        setRows(updatedList);
        if (updatedList.length != 0) {
          setEdit(true);
        } else {
          setEdit(false);
        }
      }
    }
  };

  type RowsType = IitensPedidoDiretoDialog[];

  const handleItens = (dados: IitensPedidoDiretoDialog) => {
    const index = rows.findIndex((listItem) => listItem.idprod === dados.idprod);
    let updatedList: RowsType;

    if (index !== -1) {
      updatedList = [...rows];
      const itemExistente = updatedList[index];

      const novaQuantidade = itemExistente.quantidade + dados.quantidade;
      const precoUnitario = itemExistente.preco ?? dados.preco;
      const novoTotal = novaQuantidade * precoUnitario;

      updatedList[index] = {
        ...itemExistente,
        quantidade: novaQuantidade,
        total: novoTotal,
      };
      const [movedItem] = updatedList.splice(index, 1);
      updatedList.unshift(movedItem);
    } else {
      const total = dados.quantidade * dados.preco;
      updatedList = [{ ...dados, total }, ...rows];
    }

    setRows(updatedList);
    setEdit(updatedList.length !== 0);
  };
  const handleChange = (event: SelectChangeEvent) => {
    setTipo(event.target.value as string);
  };

  const handleuuidCli = (uuid: string | undefined) => {
    if (uuid != null) {
      setUuidcli(uuid);
    }
  };
  const handleuuidProd = (uuid: string | undefined) => {
    if (uuid != null) {
      setUuidprod(uuid);
      setIsLoading(true);
      try {
        PedidoDiretoService.getProdutos(tipo, idfabrica, uuidcli, uuid)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              showError(result.message || 'Produto não encontrado');
              return;
            } else {
              handleItens({
                iditens: uuidv4(),
                idprod: result.idprod,
                idfabrica: result.idfabrica,
                quantidade: Number(quantidade),
                preco: result.preco,
                total: result.preco * Number(quantidade),
                descricao: result.descricao,
                codfabrica: result.codfabrica,
                ean: result.ean,
                nome: result.nome,
                un: result.un,
              })
            }
            setcodigobarra('');
          });
        setIsLoading(false);
        setTimeout(() => {
          codigoref.current?.focus();
        }, 0);

      } catch (error: any) {
        setIsLoading(false);
        setMsg(error.message)
        setOpenAlert(true);
        setTimeout(() => {
          codigoref.current?.focus();
        }, 0);
      }
    }
  };

  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const handleImpressao = (id: string) => {
    PedidoDiretoService.Impressao(id)
      .then(result => {
        if (result instanceof Error) {
          alert(result.message);
        } else {
          PDFPedidos(result);
        }
      });
  };

  const handleImpressao1 = (id: string) => {
    PedidoDiretoService.Impressao(id)
      .then(result => {
        if (result instanceof Error) {
          alert(result.message);
        } else {
          PDFPedidos1(result);
        }
      });
  };

  const handleImpressaopequeno = (id: string) => {
    PedidoDiretoService.Impressao(id)
      .then(result => {
        if (result instanceof Error) {
          alert(result.message);
        } else {
          PDFPedidospequeno(result);
        }
      });
  };

  const handlefabrica = (uuidfabrica: string | undefined) => {
    if (uuidfabrica != null) {
      setIdfabrica(uuidfabrica);
    } else {
      setIdfabrica('');
    }
  };

  return (
    <LayoutBaseVendas
      barraDeFerramentas={
        <FerramentasDeDetalheVendas
          textoBotaoNovo='Novo'
          mostrarBotaoImpressaoCarregando={isLoading}
          mostrarBotaoImpressaoCarregando1={isLoading}
          mostrarBotaoApagarCarregando={isLoading}
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoSalvarCarregando={isLoading}
          mostrarBotaoSalvarEFecharCarregando={isLoading}
          mostrarBotaoNovo={id !== 'novo'}
          mostrarBotaoApagar={id !== 'novo'}
          mostrarBotaoImpressao={id !== 'novo'}
          mostrarBotaoImpressaopequeno={id !== 'novo'}
          mostrarBotaoImpressao1={false}
          disableBotaoSalvar={statuss ? isLoading : true}
          disableBotaoSalvarEFechar={statuss ? isLoading : true}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          aoClicarEmVoltar={() => navigate('/pedidodireto')}
          mostrarBotaoVoltarCarregando={isLoading}
          aoClicarEmNovo={() => navigate('/pedidodireto/novo')}
          mostrarBotaoNovoCarregando={isLoading}
          aoClicarEmApagar={() => handleDeleteEntrada(id)}
          aoClicarEmImpressao={() => handleImpressao(id)}
          aoClicarEmImpressao1={() => handleImpressao1(id)}
          aoClicarEmImpressaopequeno={() => handleImpressaopequeno(id)}
        />
      }
    >
      <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Box
          margin={1}
          display="flex"
          flexDirection="column"
          component={Paper}
          variant="outlined"

        >
          <Snackbar
            open={openalert}
            autoHideDuration={1200}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert
              onClose={handleCloseAlert}
              severity="error"
              variant="filled"
              sx={{
                width: '100%',
                borderRadius: 2,
                fontWeight: 'medium'
              }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid container direction="column" padding={2} spacing={2}>
            {isLoading && (
              <Grid item>
                <LinearProgress
                  variant='indeterminate'
                  sx={{
                    borderRadius: 2,
                    height: 6
                  }}
                />
              </Grid>
            )}
            <Grid container item direction="row" spacing={2}>
              <Grid item xs={12}>
                <Grid container item direction="row" spacing={2}>
                  <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <VTextFieldData
                      fullWidth
                      name='dataoperacao'
                      label='Data Operação'
                      disabled={true}

                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <VTextFieldData
                      fullWidth
                      name='emissao'
                      label='Data do Lançamento'
                      disabled={isLoading}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <AutoCompleteCliente
                      isExternalLoading={isLoading}
                      uuidcli={handleuuidCli}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <AutoCompleteOperacoes
                      isExternalLoading={isLoading}

                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <AutoCompleteFabrica01
                      uuidfabrica={handlefabrica}
                      isExternalLoading={isLoading}

                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"

                      >
                        Tipo Pesquisa
                      </InputLabel>
                      <Select
                        size='small'
                        value={tipo}
                        label='Tipo Pesquisa'
                        onChange={handleChange}
                      >
                        <MenuItem value={'p.ean'}>Código de Barras</MenuItem>
                        <MenuItem value={'p.idprod'}>Descrição</MenuItem>
                        <MenuItem value={'p.codfabrica'}>Referência</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2} lg={1} xl={1}>
                    <TextField
                      fullWidth
                      value={quantidade}
                      inputRef={qtdref}
                      disabled={isLoading}
                      onChange={(e) => { setQuantidade(e.target.value); }}
                      size='small'
                      label='Quantidade'
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && quantidade.trim() !== '') {
                          codigoref.current?.focus();
                        }
                      }}

                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                    {tipo === 'p.ean' && (
                      <TextField
                        fullWidth
                        size='small'
                        value={codigobarra}
                        label='Código de Barras'
                        inputRef={codigoref}
                        disabled={isLoading}
                        onChange={e => setcodigobarra(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && codigobarra.trim() !== '') {
                            handlebusca(codigobarra);
                          }
                        }}

                      />
                    )}
                    {tipo === 'p.codfabrica' && (
                      <TextField
                        fullWidth
                        size='small'
                        value={codigobarra}
                        label='Referência'
                        inputRef={codigoref}
                        disabled={isLoading}
                        onChange={e => setcodigobarra(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && codigobarra.trim() !== '') {
                            handlebusca(codigobarra);
                          }
                        }}

                      />
                    )}
                    {tipo === 'p.idprod' && (
                      <AutoCompleteProdutos
                        isExternalLoading={isLoading}
                        uuidprod={handleuuidProd}

                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='numero'
                      label='Numero'
                      disabled={false}

                    />
                  </Grid>
                  <Grid item xs={6} sm={6} md={3} lg={2} xl={2}>
                    <VFieldMoney
                      fullWidth
                      size='small'
                      name='valor'
                      label='Total'
                      disabled={true}

                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TableContainer
                  component={Paper}
                  sx={{
                    maxHeight: 700,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    overflowY: 'auto',

                    // Firefox
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#cbd5e1 transparent',

                    // Chrome / Edge / Safari
                    '&::-webkit-scrollbar': {
                      width: 6,
                    },
                    '&::-webkit-scrollbar-track': {
                      background: 'transparent',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#cbd5e1',
                      borderRadius: 10,
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#94a3b8',
                    },
                  }}
                >

                  <Table stickyHeader size="small">

                    {/* HEADER */}
                    <TableHead

                    >

<TableRow
  sx={{
    '& th': {
      backgroundColor: theme =>
        theme.palette.mode === 'light'
          ? '#eff6ff'    // Azul claro (light)
          : '#334155',   // slate-700 → MAIS CLARO que antes

      color: theme =>
        theme.palette.mode === 'dark'
          ? '#e2e8f0'    // slate-200 → texto claro
          : '#475569',   // slate-600

      fontSize: '0.75rem',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.04em',

      borderBottom: '2px solid',
      borderColor: theme =>
        theme.palette.mode === 'light'
          ? '#bfdbfe'
          : '#475569',   // slate-600 → borda visível no dark

      py: 1.5,
      px: 2,

      '&:first-of-type': {
        borderTopLeftRadius: '8px',
        borderLeft: '1px solid',
        borderLeftColor: theme =>
          theme.palette.mode === 'light'
            ? '#bfdbfe'
            : '#475569',
      },

      '&:last-of-type': {
        borderTopRightRadius: '8px',
        borderRight: '1px solid',
        borderRightColor: theme =>
          theme.palette.mode === 'light'
            ? '#bfdbfe'
            : '#475569',
      },
    },
  }}
>


                        <TableCell align="center">QTD</TableCell>
                        <TableCell>CÓD BARRAS</TableCell>
                        <TableCell>DESCRIÇÃO</TableCell>
                        <TableCell>REF</TableCell>
                        <TableCell>FÁBRICA</TableCell>
                        <TableCell align="right">UNIT</TableCell>
                        <TableCell align="right">TOTAL</TableCell>
                        <TableCell align="center">AÇÕES</TableCell>
                      </TableRow>
                    </TableHead>

                    {/* BODY */}
                    <TableBody>
                      {rows.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Box
                              sx={{
                                py: 6,
                                textAlign: 'center',
                                color: 'text.secondary'
                              }}
                            >
                              <Icon sx={{ fontSize: 48 }}>inventory_2</Icon>
                              <Box fontWeight={500}>Nenhum produto adicionado</Box>
                              <Box fontSize="0.85rem">
                                Use o leitor ou pesquise para começar
                              </Box>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ) : (
                        rows.map((row, index) => (

                          <TableRow
                            key={row.iditens}
                            hover
                            sx={{
                              cursor: 'pointer',

                              '&:hover': {
                                backgroundColor: theme =>
                                  theme.palette.mode === 'light'
                                    ? '#dbeafe' // AZUL FORTE no modo claro
                                    : '#00000014', // Azul escuro no dark
                              },
                              '&:hover td': {
                                backgroundColor: 'action.hover',
                              },

                              '&.Mui-selected': {
                                backgroundColor: theme =>
                                  theme.palette.mode === 'light'
                                    ? '#bfdbfe'
                                    : '#1d4ed8',
                              },
                            }}

                          >

                            {/* QTD */}
                            <TableCell align="center">
                              <Box
                                sx={{
                                  fontWeight: 600,
                                  fontSize: '0.85rem',
                                  color: 'text.primary',
                                }}
                              >
                                {Number(row.quantidade).toLocaleString('pt-BR', {
                                  maximumFractionDigits: 0
                                })}
                              </Box>
                            </TableCell>

                            {/* EAN */}
                            <TableCell sx={{ fontFamily: 'monospace' }}>
                              {row.ean}
                            </TableCell>

                            {/* DESCRIÇÃO */}
                            <TableCell sx={{ fontWeight: 500 }}>
                              {row.descricao}
                            </TableCell>

                            {/* REFERÊNCIA */}
                            <TableCell sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                              {row.codfabrica}
                            </TableCell>


                            {/* FABRICA */}
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'inline-block',
                                  px: 1.5,
                                  py: 0.4,
                                  borderRadius: 1,
                                  backgroundColor: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#e0f2fe'
                                      : alpha(theme.palette.info.main, 0.2),
                                  color: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#0369a1'
                                      : theme.palette.info.light,
                                  fontWeight: 600,
                                  fontSize: '0.75rem',
                                }}
                              >
                                {row.nome}
                              </Box>
                            </TableCell>


                            {/* UNIT */}
                            <TableCell align="right">
                              <Box
                                sx={{
                                  display: 'inline-block',
                                  px: 1.5,
                                  py: 0.4,
                                  borderRadius: 1,
                                  backgroundColor: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#fff7ed'
                                      : alpha(theme.palette.warning.main, 0.2),
                                  color: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#9a3412b6'
                                      : theme.palette.warning.light,
                                  fontWeight: 600,
                                  fontSize: '0.75rem',
                                }}
                              >
                                R$ {row.preco.toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2
                                })}
                              </Box>
                            </TableCell>



                            {/* TOTAL */}
                            <TableCell align="right">
                              <Box
                                sx={{
                                  display: 'inline-block',
                                  px: 1.5,
                                  py: 0.5,
                                  borderRadius: 1,
                                  backgroundColor: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#ecfdf5'
                                      : alpha(theme.palette.success.main, 0.2),
                                  color: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#047857d2'
                                      : theme.palette.success.light,
                                  fontWeight: 700,
                                }}
                              >
                                R$ {row.total.toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2
                                })}
                              </Box>
                            </TableCell>


                            {/* AÇÕES */}
                            <TableCell align="center">
                              <IconButton
                                size="small"
                                onClick={() => handleDelete(row.iditens)}
                                sx={{
                                  color: 'text.secondary',
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    color: 'error.main',
                                    backgroundColor: theme =>
                                      alpha(theme.palette.error.main, 0.08),
                                  },
                                }}
                              >
                                <Icon fontSize="small">delete</Icon>
                              </IconButton>
                            </TableCell>

                          </TableRow>
                        ))
                      )}
                    </TableBody>

                    <TableFooter>
                      {isLoading && (
                        <TableRow>
                          <TableCell colSpan={7} sx={{ p: 0 }}>
                            <LinearProgress
                              variant='indeterminate'
                              sx={{
                                borderRadius: 0,
                                height: 1.5, // Altura reduzida
                                backgroundColor: 'transparent',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: theme =>
                                    theme.palette.mode === 'light'
                                      ? '#3b82f6' // Azul mais vibrante
                                      : '#60a5fa',
                                  borderRadius: 0,
                                }
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      )}
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </VForm>
      <Dialog
        open={errorDialogOpen}
        onClose={() => {
          setErrorDialogOpen(false);
          codigoref.current?.focus();
        }}
        disableEscapeKeyDown={false}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: {
            borderRadius: 3,
            border: theme => `1px solid ${theme.palette.error.light}`,
            boxShadow: theme => `0 8px 32px ${theme.palette.mode === 'light'
              ? 'rgba(211, 47, 47, 0.15)'
              : 'rgba(211, 47, 47, 0.25)'}`,
            overflow: 'hidden',
            animation: errorDialogOpen ? 'slideIn 0.3s ease' : 'none',
            '@keyframes slideIn': {
              from: {
                opacity: 0,
                transform: 'translateY(-20px) scale(0.95)',
              },
              to: {
                opacity: 1,
                transform: 'translateY(0) scale(1)',
              },
            },
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(3px)',
          },
        }}
      >
        <Box
          sx={{
            background: theme => `linear-gradient(135deg, 
        ${theme.palette.error.main} 0%, 
        ${theme.palette.error.dark} 100%)`,
            py: 2,
            px: 3,
          }}
        >
          <DialogTitle
            sx={{
              p: 0,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              color: 'white',
              fontWeight: 400,
              fontSize: '1rem',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
              }}
            >
              <Icon sx={{ color: 'white', fontSize: 24 }}>
                error_outline
              </Icon>
            </Box>
            Produto não encontrado
          </DialogTitle>
        </Box>

        <DialogContent
          sx={{
            py: 4,
            px: 3,
            backgroundColor: theme =>
              theme.palette.mode === 'light'
                ? '#fff'
                : theme.palette.grey[900],
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 2,
            }}
          >


            <Box
              sx={{
                fontSize: '1.125rem',
                fontWeight: 500,
                color: theme =>
                  theme.palette.mode === 'light'
                    ? theme.palette.grey[800]
                    : theme.palette.grey[200],
                lineHeight: 1.5,
                mb: 1,
              }}
            >
              {errorMessage}
            </Box>

            <Box
              sx={{
                fontSize: '0.875rem',
                color: theme =>
                  theme.palette.mode === 'light'
                    ? theme.palette.grey[600]
                    : theme.palette.grey[400],
                lineHeight: 1.6,
              }}
            >
              Verifique o código digitado e tente novamente.
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            pt: 2,
            backgroundColor: theme =>
              theme.palette.mode === 'light'
                ? '#fafafa'
                : theme.palette.grey[900],
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Button
            ref={okButtonRef}
            variant="contained"
            color="error"
            size="large"
            autoFocus
            onClick={() => {
              setErrorDialogOpen(false);
              codigoref.current?.focus();
            }}
            sx={{
              borderRadius: 2,
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '1rem',
              px: 4,
              py: 1.25,
              boxShadow: theme =>
                `0 4px 12px ${theme.palette.mode === 'light'
                  ? 'rgba(211, 47, 47, 0.25)'
                  : 'rgba(211, 47, 47, 0.35)'}`,
              transition: 'all 0.2s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: theme =>
                  `0 6px 16px ${theme.palette.mode === 'light'
                    ? 'rgba(211, 47, 47, 0.35)'
                    : 'rgba(211, 47, 47, 0.45)'}`,
              },
              '&:focus': {
                boxShadow: theme =>
                  `0 0 0 3px ${theme.palette.mode === 'light'
                    ? 'rgba(211, 47, 47, 0.3)'
                    : 'rgba(211, 47, 47, 0.4)'}`,
              },
            }}
          >
            OK, ENTENDI
          </Button>
        </DialogActions>
      </Dialog>
    </LayoutBaseVendas>
  );
};